angular.module('impactx.tender').controller('MostUsedTenderCtrl', MostUsedTenderCtrl);

MostUsedTenderCtrl.$inject = ['$scope', 'dataGen', 'ToolbarService'];

function MostUsedTenderCtrl($scope, dataGen, ToolbarService) {
    ToolbarService.setButtons([]);
    $scope.search = function() {
        dataGen.getData($scope, {}, '/tender/mostused');
    };

    $scope.search();

    $scope.hasTenders = function() {
        return $scope.data && $scope.data.numOfTenders && $scope.data.numOfTenders > 0
    }
}